<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      copied: false,
      title: 'Copiar'
    }    
  },
  methods: {
    copyToClipboard(text) {
      if (!text) return;
      navigator.clipboard.writeText(text)
        .then(() => {
          this.copied = true
          this.title = 'Copiado'
          setTimeout(() => {
            this.copied = false
            this.title = 'Copiar'
          }, 2000);
        })
        .catch(err => {
          console.error("Error al copiar: ", err);
        });
    }
  }
};
</script>

<template>
    <a href="javascript:void(0);" v-if="text">
      <i 
        class="mdi mdi-content-copy" 
        :class="copied ? 'text-success' : ''"
        @click="copyToClipboard(text)"
        :title="title"
        v-b-tooltip.hover
      ></i>
    </a>
</template>